import { IConceptNoteServices } from './conceptNote.types'
import { IApplication, IConceptNote } from '@/entities'
import { http } from '@/shared/https'
import { Utilities as utils } from '@/shared/utilities'
import { AppTransformers as transform } from '@/shared/transform'

export class ConceptNoteService implements IConceptNoteServices {

    createConceptNote(conceptNote: IConceptNote) {
        return http.post('api/ConceptNote', conceptNote).then((resp: any) => {
            return resp.data;
        })
    }

    /** method to get the ConceptNote data */
    getConceptNote(id: number): any {
        return http.get(`api/ConceptNote/${id}/Details`).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                throw (resp.data);
            }
        });
    }

    /** method to update the technical application */
    updateTechnicalApplication(id: number, technicalApplication: any, section = null): any {
        return http.put(`api/ConceptNote/TechnicalApplication/${id}/${section}`, technicalApplication)
            .then((resp: any) => {
                return resp.data;
            })
    }

    /** method to update the application */
    updateApplication(id: number, conceptNote: any): any {
        return http.put(`api/ConceptNote/${id}`, conceptNote).then((resp: any) => {
            return resp.data
        })
    }

    deleteConceptNote(id: number): any {
        return http.delete(`api/ConceptNote/${id}`).then((resp: any) => {
            return resp.data;
        });
    }

    ActiveUsersByUserType(userTye): any {
        return http.get(`api/ConceptNote/UserType/${userTye}/Active`)
            .then((resp: any) => {
                return resp.data;
            });
    }

    ActiveLeadUsers(userTye): any {
        return http.get(`api/ConceptNote/LeadUser/${userTye}/Active`)
            .then((resp: any) => {
                return resp.data;
            });
    }

    updatePPO(id: number, ppoid: number): any {
        return http.put(`api/ConceptNote/${id}/PrimaryProgramOfficer/${ppoid}`, {}).then((resp) => {
            if (resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        })
    }

    changeOwnership(id: number, userId: number, type: string): any {
        return http.post(`api/OwnershipTransfer/${id}/User/${userId}/${type}`, {}).then((resp) => {
            if (resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        })
    }

    getNegotiationLog(id: number) {
        return http.get(`/api/ConceptNote/${id}/NegotiationLog`,)
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status <= 300) {
                    return resp.data;
                }
            });
    }

    /** create custom indicator the PMP screen */
    createCustomIndicator(indicator: any, transactionId: number): any {
        return http.post(`/api/MEIndicator/ConceptNote/Custom/${transactionId}`, indicator)
            .then((resp: any) => {
                return resp.data;
            });
    }

    /** update the custom indicator */
    updateCustomIndicator(indicator: any, transactionId: number): any {
        indicator.Entity = 'ConceptNote';
        return http.put(`/api/MEIndicator/Custom/${transactionId}`, indicator)
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status <= 300) {
                    return resp.data;
                }
            })
    }

    /** delete the custom indicator */
    deleteCustomIndicator(id: number): any {

    }

    /** method to get the application data */
    getApplicationData(id: number): any {
        return http.get(`api/ConceptNote/${id}`).then((resp: any) => {
            return resp.data;
        });
    }

    /** method to get the application template */
    getTemplate(id: number): any {
        return http.get(`api/ConceptNote/GetTemplate/${id}`).then((resp: any) => {
            if (resp && resp.data && resp.data.Result === 'OK') {
                return resp.data.Templates.reduce((obj: any, tmpl: any) => {
                    obj[tmpl.Key] = tmpl.Value;
                    return obj;
                }, {});
            } else {
                console.log(resp.data.Message);
                return {};
            }
        });
    }
    /** method to get the technical application */
    getTechnicalApplication(id: number): any {
        return http.get(`api/ConceptNote/TechnicalApplication/${id}`).then((resp: any) => {
            return resp.data;
        });
    }

    getSnapshot(id: number): any {
        return http.get(`api/ConceptNote/Snapshot/${id}`).then((resp: any) => {
            return resp.data;
        });
    }

    getIndicators(id: number): any {
        return http.get(`/api/MEIndicator/Hierarchy/${id}`)
            .then((resp: any) => {
                if (resp.data.Result === 'OK') {
                    return resp.data.Record;
                } else {
                    return [];
                }
            });
    }
}